"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrays = void 0;
var Arrays;

(function (Arrays) {
  /**
   * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
   * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
   * multiple elements with the specified value, there is no guarantee which one will be found.
   *
   * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
   * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
   * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
   * that this guarantees that the return value will be >= 0 if and only if the key is found.
   */
  function binarySearch(array, key, fromIndex, toIndex) {
    return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
  }

  Arrays.binarySearch = binarySearch;

  function binarySearch0(array, fromIndex, toIndex, key) {
    var low = fromIndex;
    var high = toIndex - 1;

    while (low <= high) {
      var mid = low + high >>> 1;
      var midVal = array[mid];

      if (midVal < key) {
        low = mid + 1;
      } else if (midVal > key) {
        high = mid - 1;
      } else {
        // key found
        return mid;
      }
    } // key not found.


    return -(low + 1);
  }

  function toString(array) {
    var result = "[";
    var first = true;

    var _iterator = _createForOfIteratorHelper(array),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;

        if (first) {
          first = false;
        } else {
          result += ", ";
        }

        if (element === null) {
          result += "null";
        } else if (element === undefined) {
          result += "undefined";
        } else {
          result += element;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    result += "]";
    return result;
  }

  Arrays.toString = toString;
})(Arrays = exports.Arrays || (exports.Arrays = {}));